import * as React from 'react';
import { ISVGProps } from './SVG';

export function SendAirplane({ width, height, title, fill }: ISVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 15.8 15.8">
      <title>{title}</title>
      <path
        d="M15.81.63l-.06.3c-.07.45-.15.9-.22,1.35L15.3,3.63,15.08,5l-.23,1.35-.22,1.34L14.41,9l-.23,1.34L14,11.73l-.23,1.34c-.06.38-.12.76-.19,1.14a.54.54,0,0,1-.58.46.5.5,0,0,1-.21-.05L8.84,13a.08.08,0,0,0-.1,0h0L6.64,15.6a.56.56,0,0,1-1-.31V12.2a.11.11,0,0,1,0-.07q1.61-2,3.22-4L12.28,4l.93-1.14a0,0,0,0,0,0,0l0,0L10,5.67,6.7,8.5,3.87,11s0,0-.06,0L.37,9.56a.54.54,0,0,1-.31-.28A.55.55,0,0,1,.3,8.54L1.75,7.7,13.41,1,14.94.09,15.17,0h.15a.51.51,0,0,1,.41.28,1.19,1.19,0,0,1,.08.2Z"
        fill={fill}
      />
    </svg>
  );
}
